import { motion } from "framer-motion";
import { FolderArchive, Sparkles, ShieldCheck, AlertCircle } from "lucide-react";
import { tr } from "../lib/i18n";

const Stat = ({ icon: Icon, label, value, accent, testid, delay }) => (
  <motion.div
    data-testid={testid}
    initial={{ opacity: 0, y: 12 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.4, delay }}
    className="paper-card bg-card border border-border rounded-2xl p-4 sm:p-5 flex items-center gap-4"
  >
    <div className={`h-11 w-11 rounded-xl grid place-items-center shrink-0 ${accent}`}>
      <Icon className="h-5 w-5" />
    </div>
    <div className="min-w-0">
      <div className="text-2xl font-serif font-semibold leading-none">{value}</div>
      <div className="text-xs uppercase tracking-wider font-mono text-muted-foreground mt-1.5">
        {label}
      </div>
    </div>
  </motion.div>
);

export const StatsShelf = ({ stats }) => {
  const s = stats || {};
  return (
    <div data-testid="vault-stats-shelf" className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
      <Stat
        testid="stat-total-docs"
        icon={FolderArchive}
        label={tr("Documents Filed")}
        value={s.total ?? "–"}
        accent="bg-primary/10 text-primary"
        delay={0.02}
      />
      <Stat
        testid="stat-categories"
        icon={Sparkles}
        label={tr("Active Categories")}
        value={s.categories_active ?? "–"}
        accent="bg-sky-500/10 text-sky-600 dark:text-sky-400"
        delay={0.08}
      />
      <Stat
        testid="stat-vault-health"
        icon={ShieldCheck}
        label={tr("Vault Health")}
        value={s.vault_health != null ? `${s.vault_health}%` : "–"}
        accent="bg-emerald-500/10 text-emerald-600 dark:text-emerald-400"
        delay={0.14}
      />
      <Stat
        testid="stat-pending-review"
        icon={AlertCircle}
        label={tr("Needs Review")}
        value={s.needs_review ?? "–"}
        accent="bg-amber-500/10 text-amber-600 dark:text-amber-400"
        delay={0.2}
      />
    </div>
  );
};
